import React from 'react';
import { useTranslation } from 'react-i18next';
import { Carousel } from 'antd';
import styled from 'styled-components';

const CarouselWrapp = styled.div`
    padding-top: 3rem;
`;

const Gallery = props => {
    const { t } = useTranslation();

    return (
        <>
            <CarouselWrapp>
                <Carousel autoplay>
                    {props.data.map(el => {
                        return (
                            <div>
                                <img src={el.img} alt={'slide'}></img>
                            </div>
                        );
                    })}
                </Carousel>
            </CarouselWrapp>
        </>
    );
};

export default Gallery;
